import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import sidenav from "assets/theme/components/sidenav";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 260;
  const { transparent, gradients, white, background, light } = palette;
  const { xxl } = boxShadows;
  const { pxToRem, linearGradient } = functions;
  const { sideNav } = colors;

  let backgroundValue = darkMode ? background.sidenav : `${sideNav.backGround}`;
  // linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      // boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      // boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(96),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      // boxShadow: xxl,
      // borderRight: "1px dotted #888",
      // borderRadius: "0",
      // overflowY: "auto",
      // // "&:hover": {
      // //   overflowY: "auto",
      // // },
      // "&::-webkit-scrollbar": {
      //   width: "0.4rem",
      // },
      // "&::-webkit-scrollbar-track": {
      //   backgroundColor: "transparent",
      // },
      // "&::-webkit-scrollbar-thumb": {
      //   backgroundColor: "#adb5bd ",
      //   borderRadius: "10px",
      //   cursor: "pointer",
      // },

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
